import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";

class ProbationList extends Component {
  render() {
    const { action } = this.props;
    const probations = this.props.probations.filter((o) => !o._destroy);

    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Notes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            probations.map((l, i) => {
              return (
                <tr key={i}>
                  <td>{l.starts_at && moment(l.starts_at).format("MM/DD/YYYY")}</td>
                  <td>{l.ends_at && moment(l.ends_at).format("MM/DD/YYYY")}</td>
                  <td>{l.notes}</td>
                  <td>
                    {
                      action === "edit" &&
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.editProbation(l);
                        }}>
                        Edit
                      </a>
                    }
                  </td>
                </tr>
              );
            })
          }
          {
            action == "edit" &&
            <tr>
              <td colSpan={7} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    this.props.newProbation();
                  }}>
                  Add Probation
                </Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    probations: state.probations,
    action: state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    newProbation: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "probation" }
      })
    },
    editProbation: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName: "probation", resource }
      })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProbationList);
